var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnsCafeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_48_40867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.1328 17.6602C35.1328 7.99517 27.2978 0.160156 17.6328 0.160156C7.96783 0.160156 0.132812 7.99517 0.132812 17.6602C0.132812 27.3251 7.96783 35.1602 17.6328 35.1602C27.2978 35.1602 35.1328 27.3251 35.1328 17.6602Z",
    fill: "#EE3F4A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.8375 28.3571C23.7452 28.3571 28.5344 23.568 28.5344 17.6603C28.5344 11.7525 23.7452 6.96338 17.8375 6.96338C11.9298 6.96338 7.14062 11.7525 7.14062 17.6603C7.14062 23.568 11.9298 28.3571 17.8375 28.3571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7017 19.2204H25.91C25.0496 19.2204 24.3496 18.5204 24.3496 17.66C24.3496 16.7996 25.0496 16.0996 25.91 16.0996H29.7017C30.5621 16.0996 31.2621 16.7996 31.2621 17.66C31.2621 18.5204 30.5621 19.2204 29.7017 19.2204Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3488 18.7687C23.4436 19.5197 24.1363 19.8187 24.8581 19.6072C25.0186 19.5635 25.1717 19.4687 25.3175 19.3885C25.6238 19.228 25.8717 19.2645 26.0248 19.5197C26.1925 19.8041 26.0686 20.0083 25.8425 20.1905C25.179 20.7301 23.9759 20.7958 23.1956 20.3437C22.3717 19.8624 21.9852 19.002 22.1384 17.9374C22.255 17.0916 22.8967 16.3843 23.7425 16.151C25.0623 15.7937 26.3894 16.778 26.4186 18.1416C26.4259 18.5353 26.1925 18.7687 25.7769 18.776C24.9748 18.776 24.18 18.776 23.3561 18.776L23.3488 18.7687ZM25.2154 18.0176C25.0696 17.303 24.7488 17.026 24.18 17.0697C23.7206 17.1062 23.3852 17.4853 23.3488 18.0176H25.2154Z",
    fill: "#EE3F4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7727 20.1028C16.1967 20.657 15.5404 20.7445 14.8331 20.5257C14.2863 20.358 13.98 19.9059 13.9654 19.3299C13.9508 18.7028 14.2133 18.2653 14.7675 18.0538C15.3581 17.8278 15.9706 17.8351 16.5758 17.9955C16.6415 18.0101 16.7144 18.0174 16.7873 18.0247C16.8165 17.4632 16.5685 17.1715 15.9925 17.1497C15.679 17.1351 15.3581 17.2007 15.0446 17.259C14.6581 17.332 14.3665 17.2153 14.3154 16.9018C14.2571 16.559 14.4758 16.384 14.7675 16.2965C15.4165 16.107 16.0654 16.034 16.729 16.1872C17.4508 16.3549 17.9321 16.9018 17.9613 17.6455C17.9904 18.3747 17.9904 19.0965 17.9904 19.8257C17.9904 20.2997 17.8519 20.5111 17.5165 20.5913C17.2321 20.6643 16.9915 20.5111 16.7581 20.1028H16.7727ZM16.08 18.608C16.08 18.608 15.606 18.6518 15.4092 18.7538C15.0446 18.9507 15.0519 19.4903 15.4092 19.7018C15.7956 19.9351 16.481 19.7747 16.7363 19.3955C17.0133 18.9872 16.8967 18.7101 16.4154 18.6226C16.306 18.6007 16.1967 18.608 16.0873 18.6007L16.08 18.608Z",
    fill: "#EE3F4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6826 20.6423C10.341 20.6423 9.42221 19.8475 9.26908 18.6007C9.14512 17.5725 9.78679 16.4423 10.968 16.1725C11.6462 16.0121 12.3097 16.0632 12.9149 16.4569C13.2649 16.6903 13.367 17.0184 13.1774 17.2955C13.0024 17.558 12.6743 17.5871 12.3316 17.3757C11.8139 17.0621 11.3107 17.0548 10.9243 17.3538C10.5305 17.6673 10.3701 18.309 10.5597 18.834C10.8003 19.5194 11.5149 19.7965 12.1857 19.4684C12.3024 19.41 12.4118 19.308 12.5285 19.2569C12.791 19.1548 13.0462 19.1548 13.2139 19.4173C13.3889 19.6725 13.3232 19.9132 13.0972 20.1027C12.6597 20.4746 12.1493 20.6642 11.6826 20.635V20.6423Z",
    fill: "#EE3F4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3677 17.2591C19.076 17.1497 18.8063 17.0622 18.799 16.7195C18.7917 16.3549 19.076 16.2674 19.3531 16.1507C19.3677 15.9466 19.375 15.7351 19.3969 15.531C19.499 14.6851 20.7313 14.1237 21.4094 14.6341C21.5333 14.7289 21.6427 15.006 21.5917 15.1299C21.526 15.2903 21.3073 15.4653 21.125 15.5018C20.6656 15.5966 20.5635 15.6695 20.5854 16.1653C20.9646 16.282 21.6281 16.0268 21.599 16.7414C21.5771 17.3612 20.9938 17.1643 20.5708 17.2372V19.3737C20.5708 19.556 20.5708 19.7455 20.5708 19.9278C20.5635 20.3216 20.3302 20.5914 19.9948 20.6132C19.6448 20.6351 19.375 20.3653 19.3677 19.9424C19.3531 19.1768 19.3677 18.4112 19.3677 17.6455V17.2591Z",
    fill: "#EE3F4A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_40867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0.132812 0.160156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsCafeCircle);
export default __webpack_public_path__ + "static/media/sns_cafe_circle.a143449842505b961268f2bdd66c2e15.svg";
export { ForwardRef as ReactComponent };